import { InjectionToken } from '@angular/core';
import { ModalWizardModels } from './models/modal-wizard.model';

export const MODAL_WIZARD_CONFIG_TOKEN = new InjectionToken<ModalWizardModels.WizardConfig>('modalWizardCustom.config');
